export default "__VITE_ASSET__L717C5G8__"